import React, { useState, useEffect, useRef, useMemo, Fragment, useCallback } from "react";
import axios from "axios";
import ArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { observer } from "mobx-react-lite";
import { Combobox, Transition } from "@headlessui/react";
import SystemLabel from "../../components/SystemLabel";
import useOnClickOutside from "../../hooks/onClickOutside";

const includes = (source, target) => source?.toLowerCase()?.includes(target.toLowerCase());

export const CountrySelect = observer((props) => {
  const containerRef = useRef(null);
  const [countries, setCountries] = useState([]);
  const [query, setQuery] = useState("");
    const [open, setOpen] = useState(false);
    const { lang, eventId, selectGrid, value, onChange, useCode = false, countryCode, loaded, valid = undefined, preselected } = props;

  useOnClickOutside([{ current: containerRef.current }], () => setOpen(false), open);

  useEffect(() => {
    if (lang && eventId) getCountries();
  }, [lang, eventId]);

  useEffect(() => {
    if (typeof loaded === "function") {
      if (countries.length > 0 && loaded) loaded(true);
      if (countries.length > 0 && (value || countryCode) && value) {
        const country = countries.find((t) => t.countryCode === countryCode || t.value == value);
        onChange(country?.value, country);
      }
    }
  }, [value, countries, countryCode, loaded]);

  const getCountries = useCallback(async () => {
    try {
      const requestOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      };
      const { data } = await axios.get(`./api/country/getselection/${eventId}/${lang}`, requestOptions);
      const countryList = [{ value: 0, label: "", europeCountry: null, nordicCountry: null, countryId: 0 }, ...data].map((c, index) =>
        index > 0
          ? {
              value: c.countryId,
              label: lang == "swe" || lang === undefined ? c.nameSwe : c.nameInt,
              europeCountry: c.europeCountry === null ? false : c.europeCountry,
              nordicCountry: c.nordicCountry === null ? false : c.nordicCountry,
              swedishCountry: c.nameInt == "Sweden" ? true : false,
              countryCode: c.code,
              name: c.nameInt,
            }
          : c
      );
      setCountries(countryList);
    } catch (error) {
      console.error(error);
    }
  }, [useCode]);

  const filteredCountries = useMemo(() => {
    if (selectGrid && selectGrid?.only?.length) {
      return countries.filter(({ name }) => includes(name, query) && includes(selectGrid.exceptions, name));
    }
    if (query === "") return [...countries]?.splice(0, 10);
    return countries.filter(({ label }) => includes(label, query));
  }, [selectGrid, countries, query]);

  const selectedCountry = useMemo(() => {
    let found = countries?.find(({ value: _value }) => _value === value);
    if (!found && preselected) {
      let precountry = countries.find((x) => x.value == preselected);
      if (!precountry) return found;
      found = precountry.value;
      //console.log("pciutn", precountry, found, value);
      //onChange(precountry.value, precountry, false);
    }
    return found;
  }, [countries, value, preselected]);

  useEffect(() => {
    if (preselected && selectedCountry && (preselected==selectedCountry || preselected==selectedCountry?.value)) {
      let precountry = countries.find((x) => x.value == preselected);
      if (precountry && precountry.value) {
        //console.log(precountry.value, selectedCountry);
        onChange(precountry.value, precountry, false);
      }
    } else {
    }
  }, [selectedCountry, preselected]);

  const handleChange = useCallback(
    (country) => {
      onChange(country.value, country, false);
      setOpen(false);
    },
    [onChange]
  );

  return (
    <div className="select-wrap selector" ref={containerRef}>
      <Combobox value={selectedCountry ?? {}} onChange={handleChange}>
        <div className="autocomplete">
          <div className="input-base">
            <Combobox.Input
              onClick={() => setOpen((prev) => !prev)}
              onChange={(event) => setQuery(event.target.value)}
              displayValue={(props) => props?.label ?? ""}
              className="cms-field person form-control"
                          style={{ marginLeft: 0, border: valid === false ? "1px solid #d53443" : undefined }}
            />
            <Combobox.Button onClick={() => setOpen((prev) => !prev)}>
              <ArrowDownIcon />
            </Combobox.Button>
          </div>
          <Transition show={open} as={Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0" afterLeave={() => setQuery("")}>
            <Combobox.Options>
              {filteredCountries?.length === 0 ? (
                <div style={{ padding: 10 }}>
                  <SystemLabel name="NoResult" />
                </div>
              ) : (
                filteredCountries?.map((country) => (
                  <Combobox.Option key={country.value} value={country} as={Fragment}>
                    {({ selected }) => <li className={selected ? "selected" : ""}>{country.label}</li>}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </div>
  );
});
